/* eslint-disable @typescript-eslint/no-empty-function */

// ─────────────────────────────────────────────────────────────────────────────

// NOTE: iOS only
export const useInitializeLiveActivities = () => {};
